import React from 'react'
import { SharedDataListableTable } from './SharedDataListableTable'

interface IDoctorSharedDataTableProps {}
export const DoctorSharedDataTable: React.FC<IDoctorSharedDataTableProps> = props => {
  return <SharedDataListableTable isDoctor={true} />
}
